var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pagination',{attrs:{"current-page":1,"component-name":"StandardArticle","data-attribute-name":"payload","data-list":_vm.articlesByTag,"entries-per-page":3,"key-function":function (entry, index) { return index; }}})}
var staticRenderFns = []

export { render, staticRenderFns }